import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';
import { themeType } from '../../../common/theme-colors';

const CARD_WIDTH = 240;

export const makeStyles = (colors: themeType) =>
  StyleSheet.create({
    card: {
      width: CARD_WIDTH,
      borderRadius: theme.radius.medium,
      backgroundColor: colors.popupBg,
      borderWidth: 1,
      borderColor: colors.borderColor,
      ...theme.shadow.light,
      overflow: 'hidden',
      position: 'relative',
      marginTop: 20,
    },
    badge: {
      position: 'absolute',
      top: 8,
      right: 5,
      backgroundColor: colors.green,
      paddingHorizontal: 12,
      paddingVertical: 6,
      borderRadius: theme.radius.medium,
      zIndex: 1,
      ...theme.shadow.light,
    },
    badgeText: {
      color: colors.white,
      fontSize: theme.fontSize.xs,
      fontWeight: '600',
      lineHeight: 16,
    },
    imageContainer: {
      width: '100%',
      height: 220,
      backgroundColor: colors.elevation1,
    },
    image: {
      width: '100%',
      height: '100%',
    },
    imagePlaceholder: {
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.elevation1,
    },
    placeholderText: {
      fontSize: theme.fontSize.xl,
      color: colors.textLight,
      fontFamily: theme.fonts.bold,
    },
    details: {
      padding: 16,
      gap: 8,
      flex: 1,
      justifyContent: 'space-between',
    },
    name: {
      fontSize: theme.fontSize.small,
      lineHeight: 22,
      maxHeight: 44,
      fontWeight: '500',
      color: colors.text,
    },
    description: {
      lineHeight: 20,
      maxHeight: 40,
      color: colors.textLight,
    },
    price: {
      lineHeight: 24,
      height: 24,
      fontWeight: '500',
      marginTop: 4,
      color: colors.text,
    },
  });
